import { render, staticRenderFns } from "./ForumTopic.vue?vue&type=template&id=4ee842ca&"
import script from "./ForumTopic.vue?vue&type=script&lang=js&"
export * from "./ForumTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports